'use strict';

import $ from 'jquery';
import 'jquery-match-height';

export default class Sitemap {
  constructor() {
    let $sitemap = $('.sitemap'),
        $sitemapItems = $sitemap.find('.sitemap__each');

        $sitemapItems.matchHeight();
    
  }
}
